const MODAL_DOMAIN = 'modal'

/**
 * The modal's initial state.
 * @type {Object}
 */
const MODAL_STATE = {
  current: null,
  data: null
}

/**
 * A mapping of key to modal id.
 * @type {Object}
 */
const MODAL_ID = {
  ACHIEVEMENT: 'ACHIEVEMENT',
  ANDROID_DOWNLOAD: 'MODAL_ANDROID_DOWNLOAD',
  BLANK: 'MODAL_BLANK',
  CANCEL_YOUR_SUBSCRIPTION: 'MODAL_CANCEL_YOUR_SUBSCRIPTION',
  CHANGE_PASSWORD: 'MODAL_CHANGE_PASSWORD',
  CONFIRM: 'MODAL_CONFIRM',
  CHECKOUT: 'MODAL_CHECKOUT',
  CURRENCIES: 'MODAL_CURRENCIES',
  CREATOR_TRAINING_PURCHASE_MODAL: 'CREATOR_TRAINING_PURCHASE_MODAL',
  CREATOR_PLAN_INFO: 'CREATOR_PLAN_INFO',
  CREATOR_WORKOUT_INFO: 'CREATOR_WORKOUT_INFO',
  CREATOR_CHAT_MODAL: 'CREATOR_CHAT_MODAL',
  EQUIPMENT_LIST: 'EQUIPMENT_LIST',
  EDIT_ACCOUNT_PROPERTY: 'EDIT_ACCOUNT_PROPERTY',
  EXERCISE_TYPES_LIST: 'EXERCISE_TYPES_LIST',
  EXIT_STARTED_WORKOUT_CONFIRM: 'EXIT_STARTED_WORKOUT_CONFIRM',
  MUSCLES_LIST: 'MUSCLES_LIST',
  MOBILE_HEADER: 'MOBILE_HEADER',
  NEW: 'MODAL_NEW',
  NOTIFICATIONS_MENU: 'MODAL_NOTIFICATIONS_MENU',
  NEWSLETTER: 'MODAL_NEWSLETTER',
  PAYMENT: 'MODAL_PAYMENT',
  PROFILE_FITNESS_DATA: 'MODAL_PROFILE_FITNESS_DATA',
  RESET_PASSWORD: 'MODAL_RESET_PASSWORD',
  SIGNIN: 'MODAL_SIGNIN',
  APP_SIGN_IN: 'MODAL_APP_SIGN_IN',
  USER_MENU: 'MODAL_USER_MENU',
  VERIFY_EMAIL: 'MODAL_VERIFY_EMAIL',
  WORKOUT_SET_INFO: 'WORKOUT_SET_INFO',
  SET_ROW_MENU: 'SET_ROW_MENU',
  WORKOUT_SECTION_EDIT: 'WORKOUT_SECTION_EDIT'
}

module.exports =
  {
    MODAL_DOMAIN,
    MODAL_STATE,
    MODAL_ID
  }
